import { Navigate } from "react-router-dom";
import { usePOS } from "@/context/POSContext";
import { useIsMobile } from "@/hooks/useIsMobile";

/** May this person use the captain pad? Their own switch once the session
 *  carries permissions, the role list for a session cached before that. */
export function canUsePad(user, permissions) {
  if (Array.isArray(permissions) && permissions.length) return permissions.includes("pages.captain");
  return ["admin", "captain"].includes(user?.role);
}

/**
 * POS follows the device (owner, 2026-10-25: "POS was built focused around pc
 * while captainpad was focused around phone"). On a phone the billing tables
 * page opens CaptainPAD instead, for anyone allowed the pad; on a PC or tablet,
 * and for anyone without the pad, it is the billing page as before.
 */
export default function PhonePos({ children }) {
  const { user, permissions } = usePOS();
  const isPhone = useIsMobile(767);
  if (isPhone && canUsePad(user, permissions)) return <Navigate to="/captain" replace />;
  return children;
}
